export default (pnrInfo) => {
  let destination = 'NA';
  let origin = 'NA';
  const legCollection = pnrInfo?.legCollection || [];
  const flightType = pnrInfo?.flightItineraryType;

  const outboundSegments = legCollection?.[0]?.segmentsCollection;
  const inboundSegments = legCollection?.[legCollection?.length - 1]?.segmentsCollection;
  const inboundDepartureDate = pnrInfo?.flightItineraryType === 'ROUNDTRIP' ? inboundSegments?.[0]?.departureDateTime?.format('YYYYMMDD') : 'NA';
  const inboundArrivalDate = pnrInfo?.flightItineraryType === 'ROUNDTRIP' ? inboundSegments?.[inboundSegments?.length - 1]?.arrivalDateTime?.format('YYYYMMDD') : 'NA';
  const outboundDepartureDate = outboundSegments?.[0]?.departureDateTime?.format('YYYYMMDD') || 'NA';
  const outboundArrivalDate = outboundSegments?.[outboundSegments?.length - 1]?.arrivalDateTime?.format('YYYYMMDD');
  const outBoundDepartureDateMultiCity = (legCollection || []).map((legData) => {
    const segmentCollection = legData?.segmentsCollection || [];
    const segments = segmentCollection.map(segment => {
      const departureDate = segment?.departureDateTime?.format('YYYYMMDD') || 'NA';
      return departureDate;
    }).join('/');
    return segments;
  }).join('-');
 
  const outBoundArrivalDateMultiCity = (legCollection || []).map((legData) => {
    const segmentCollection = legData?.segmentsCollection || [];
    const segments = segmentCollection.map(segment => {
      const arrivalDate = segment?.arrivalDateTime?.format('YYYYMMDD') || 'NA';
      return arrivalDate;
    }).join('/');
    return segments;
  }).join('-');

  if (flightType === 'ROUNDTRIP' || flightType === 'ONEWAY') {
    origin = legCollection?.[0]?.segmentsCollection?.[0]?.departureAirport || 'NA';
    destination = legCollection?.[0]?.segmentsCollection?.slice(-1)?.[0]?.arrivalAirport || 'NA';
  } else {
    origin = legCollection?.map(legs => {
      const segmentCollection = legs?.segmentsCollection || [];
      const segmentOrigin = segmentCollection?.[0]?.departureAirport || 'NA';
      return segmentOrigin;
    }).join('-');
    destination = legCollection?.map(legs => {
      const segmentCollection = legs?.segmentsCollection || [];
      const segmentDestination = segmentCollection?.slice(-1)?.[0]?.arrivalAirport || 'NA';
      return segmentDestination;
    }).join('-');
  }

  function getRegionValue(marketType, regionCode) {
    const regionCodeMap = {
      'CAN': 'CAN',
      'USA': 'USA',
    };
    const regionMap = {
      'ASI': 'ASI',
      'ASIA': 'ASI',
      'CANADA': 'CAN',
      'CENTROAMERICA': 'CAM',
      'CENTROAMERICA_CARIBE': 'CAR',
      'DOMESTIC': 'DOM',
      'EUROPA': 'EUR',
      'Frontera': 'FRO',
      'Local': 'LOC',
      'Playa': 'PLA',
      'SUDAMERICA_ASIA': 'SUD',
      'SUDSH': 'SUD',
      'SUDLH': 'SUD',
      'CAN': 'CAN',
      'CAM': 'CAM',
      'CAR': 'CAR',
      'DOM': 'DOM',
      'EUR': 'EUR',
      'FRO': 'FRO',
      'LOC': 'LOC',
      'PLA': 'PLA',
      'SUD': 'SUD',
    };

    if (marketType === 'TRANSBORDER') {
      return regionCodeMap[regionCode] || 'DOM';
    } else {
      return regionMap[marketType] || 'DOM';
    }
  }

  const region = getRegionValue(legCollection?.[0]?.legRegion, legCollection?.[0]?.regionKey);
  const isInternationalFlight = legCollection?.some(legs => legs?.marketFlight !== 'DOMESTIC');
  const zone = isInternationalFlight ? 'INT' : 'DOM';
  const tripType = flightType === 'ONEWAY' ? 'OW' : flightType === 'ROUNDTRIP' ? 'RT' : 'MC';
  
  return {
    event: 'sr_step_init',
    'funnel_name': 'SR',
    'sub_funnel_name':'SR-involuntary_init',
    'outbound_departure_date': tripType === 'MC' ? outBoundDepartureDateMultiCity : outboundDepartureDate,
    'inbound_departure_date': inboundDepartureDate,
    'outbound_arrival_date': tripType === 'MC' ? outBoundArrivalDateMultiCity : outboundArrivalDate,
    'inbound_arrival_date': inboundArrivalDate,
    'origin': origin,
    'destination': destination,
    'zone': zone,
    'trip_type': tripType,
    'change_type': 'Involuntary',
    'change_reason': 'IROPS',
    'region': region,
  };
};